import Reflux from 'reflux';

const PrintableCuesheetActions = Reflux.createActions({
  setGuest: {},
  clear: {},
});

export default PrintableCuesheetActions;
